// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3FEMF","header":"Messages_header__1Dvms"};